if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
   
constructor() {
  super();

  let startX = 0;
  let startY = 0;

  this.addEventListener('touchstart', (event) => {
    if (window.innerWidth >= 750 || event.touches.length !== 1) return;

    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  this.addEventListener('touchend', (event) => {
    if (window.innerWidth >= 750 || !this.hasAttribute('open')) return;

    const touch = event.changedTouches[0];
    if (!touch) return;

    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;

    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;

    const items = Array.from(
      this.querySelectorAll('.product-media-modal__content > [data-media-id]')
    ).filter(item => getComputedStyle(item).display !== 'none');

    if (items.length < 2) return;

    const current = items.findIndex(item => item.classList.contains('active'));
    if (current === -1) return;

    const next = (current + (dx < 0 ? 1 : -1) + items.length) % items.length;

    items[current].classList.remove('active');
    items[next].classList.add('active');

    items[next].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, { passive: true });
}


      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
